import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import partnerShipmentStatusService from "./partnerShipmentStatusService";

const initialState = {
  getPartnerShipmentStatusOrdersLoading: true,
  getPartnerShipmentStatusOrdersResult: null,
  getPartnerShipmentStatusOrdersError: null,

  getPartnerCurrentLocationLoading: false,
  getPartnerCurrentLocationResult: null,
  getPartnerCurrentLocationError: null,
};

export const getPartnerShipmentStatusOrders = createAsyncThunk(
  "statusUpdates/getPartnerShipmentStatusOrders",
  async (signature, thunkAPI) => {
    try {
      const ISO = thunkAPI.getState().lang.ISO;
      return await partnerShipmentStatusService.getPartnerShipmentStatusOrders(ISO, signature);
    } catch (error) {
      const message = (error.response && error.response.data) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getPartnerCurrentLocation = createAsyncThunk(
  "statusUpdates/getPartnerCurrentLocation",
  async (data, thunkAPI) => {
    try {
      const ISO = thunkAPI.getState().lang.ISO;
      return await partnerShipmentStatusService.getPartnerCurrentLocation(ISO, data);
    } catch (error) {
      const message = (error.response && error.response.data) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const partnerShipmentStatusSlice = createSlice({
  name: "partnerShipmentStatus",
  initialState,
  reducers: {
    resetGetPartnerShipmentStatusOrders: (state) => {
      state.getPartnerShipmentStatusOrdersLoading = true;
      state.getPartnerShipmentStatusOrdersResult = null;
      state.getPartnerShipmentStatusOrdersError = null;
    },
    resetGetPartnerCurrentLocation: (state) => {
      state.getPartnerCurrentLocationLoading = false;
      state.getPartnerCurrentLocationResult = null;
      state.getPartnerCurrentLocationError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPartnerShipmentStatusOrders.pending, (state) => {
        state.getPartnerShipmentStatusOrdersLoading = true;
        state.getPartnerShipmentStatusOrdersResult = null;
        state.getPartnerShipmentStatusOrdersError = null;
      })
      .addCase(getPartnerShipmentStatusOrders.fulfilled, (state, action) => {
        state.getPartnerShipmentStatusOrdersLoading = false;
        state.getPartnerShipmentStatusOrdersResult = action.payload;
        state.getPartnerShipmentStatusOrdersError = null;
      })
      .addCase(getPartnerShipmentStatusOrders.rejected, (state, action) => {
        state.getPartnerShipmentStatusOrdersLoading = false;
        state.getPartnerShipmentStatusOrdersResult = null;
        state.getPartnerShipmentStatusOrdersError = action.payload;
      })

      .addCase(getPartnerCurrentLocation.pending, (state) => {
        state.getPartnerCurrentLocationLoading = true;
        state.getPartnerCurrentLocationResult = null;
        state.getPartnerCurrentLocationError = null;
      })
      .addCase(getPartnerCurrentLocation.fulfilled, (state, action) => {
        state.getPartnerCurrentLocationLoading = false;
        state.getPartnerCurrentLocationResult = action.payload;
        state.getPartnerCurrentLocationError = null;
      })
      .addCase(getPartnerCurrentLocation.rejected, (state, action) => {
        state.getPartnerCurrentLocationLoading = false;
        state.getPartnerCurrentLocationResult = null;
        state.getPartnerCurrentLocationError = action.payload;
      });
  },
});

export const { resetGetPartnerCurrentLocation, resetGetPartnerShipmentStatusOrders } =
  partnerShipmentStatusSlice.actions;
export default partnerShipmentStatusSlice.reducer;
